module.exports = __webpack_public_path__ + "img/punto-venta.8785e28a.jpg";